import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { alpha } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { _socials } from 'src/_mock';

import Logo from 'src/components/logo';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'SatyendraInTech',
    children: [
      { name: 'About', href: paths.about },
      { name: 'Contact', href: paths.contact },
    ],
  },
  {
    headline: 'Legal',
    children: [
      { name: 'Terms and Condition', href: '#' },
      { name: 'Privacy Policy', href: '#' },
      { name: 'FAQs', href: paths.faqs },
    ],
  },
  {
    headline: 'Contact',
    children: [
      { name: 'satyendrasr.career@gmail.com', href: '#' },
      { name: '+91 78 6935 1845', href: '#' },
      { name: 'LandLine Number +91 8041330131', href: '#' },
      {
        name: 'Bengaluru, Karnataka 560068',
        href: '#',
      },
    ],
  },
];

// ----------------------------------------------------------------------

export default function Footer() {
  const mainFooter = (
    <>
      <Box
        width="100%"
        alt="aboutme"
        component={m.img}
        src="/assets/icons/footer/beforefooter.svg"
      />
      <Box
        component="footer"
        sx={{
          position: 'relative',
          bgcolor: 'grey.900',
          color: 'common.white',
        }}
      >
        <Container
          sx={{
            pt: 5,
            pb: 5,
            textAlign: { xs: 'center', md: 'unset' },
          }}
        >
          <Logo sx={{ mb: 3 }} />
          <Grid
            container
            justifyContent={{
              xs: 'center',
              md: 'space-between',
            }}
          >
            <Grid xs={12} md={4}>
              <Typography
                variant="body2"
                sx={{
                  mx: { xs: 'unset', md: 'unset' },
                  mb: { xs: 2, md: 0 },
                  textAlign: 'justify',
                }}
              >
                With 4+ years of experience in React.js and full stack development, I build
                intuitive interfaces and scalable web solutions—seamlessly integrating backends,
                Yellow.ai bots, and NLP. Let’s bring your digital ideas to life! 🚀
              </Typography>
            </Grid>
            <Grid xs={12} md={6}>
              <Stack spacing={5} direction={{ xs: 'column', md: 'row' }}>
                {LINKS.map((list) => (
                  <Stack
                    key={list.headline}
                    spacing={2}
                    alignItems={{ xs: 'center', md: 'flex-start' }}
                    sx={{ width: 1 }}
                  >
                    <Typography component="div" variant="overline">
                      {list.headline}
                    </Typography>

                    {list.children.map((userLink) => (
                      <Link
                        key={userLink.name}
                        component={RouterLink}
                        href={userLink.href}
                        variant="body2"
                        color="inherit"
                        sx={{
                          '&:hover': {
                            opacity: 0.8,
                          },
                        }}
                      >
                        {userLink.name}
                      </Link>
                    ))}
                  </Stack>
                ))}
              </Stack>
            </Grid>
          </Grid>
          <Box
            sx={{
              mt: { md: 5, xs: 5 },
            }}
            display="flex"
            flexDirection={{ md: 'row', xs: 'column' }}
            alignItems="center"
            alignContent="center"
            justifyContent={{ md: 'space-between', xs: 'center' }}
            color="text.disabled"
          >
            <Typography variant="body2" sx={{ mb: 2 }}>
              &copy; 2025 Satyendra Singh • SatyaTechnical Portfolio. All rights reserved.
            </Typography>
            <Stack direction="row" justifyContent={{ xs: 'center', md: 'flex-start' }}>
              {_socials.map((social) => (
                <IconButton
                  aria-label="Footer Social List"
                  component={RouterLink}
                  href={social.link}
                  key={social.name}
                  target="_blank"
                  sx={{
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      bgcolor: alpha(social.color, 0.08),
                      transform: 'scale(1.1)',
                    },
                  }}
                >
                  <Iconify width={24} height={24} color={social.color} icon={social.icon} />
                </IconButton>
              ))}
            </Stack>
          </Box>
        </Container>
      </Box>
    </>
  );

  return mainFooter;
}
